import { render, staticRenderFns } from "./OrganPersonBasicInfoEdit.vue?vue&type=template&id=ff7877ec&scoped=true"
import script from "./OrganPersonBasicInfoEdit.vue?vue&type=script&lang=js"
export * from "./OrganPersonBasicInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7877ec",
  null
  
)

export default component.exports